import { FC, useMemo } from 'react'

import { Modal } from '@inno-ui/modal'
import { useTranslation } from 'react-i18next'

import {
  MODAL_MAX_HEIGHT,
  MODAL_MAX_WIDTH,
  MODAL_Z_INDEX
} from './DiscoverAppsModal.constant'
import { DiscoverAppsModalProps } from './DiscoverAppsModal.types'
import { DiscoverModalContent } from './components'

export const DiscoverAppsModal: FC<DiscoverAppsModalProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'discover_apps'
  })

  const modalTitle = useMemo(() => t('title'), [t])

  return (
    <Modal
      isOpen={isOpen}
      maxWidth={MODAL_MAX_WIDTH}
      maxHeight={MODAL_MAX_HEIGHT}
      onClose={onClose}
      title={modalTitle}
      showHeader
      withHeaderLine={false}
      zIndex={MODAL_Z_INDEX}
      layers={[
        {
          title: modalTitle,
          header: {},
          bodyPaddings: false,
          body: <DiscoverModalContent />
        }
      ]}
    />
  )
}
